module.exports = __webpack_public_path__ + "static/media/CENARIO_anima.ce74ced1.jpg";